export enum FormShipperInformationFormValues {
    shipperId = "entityID",
    shipperName = 'entityName',
    shipperEmail = 'email',
    shipperPhone = 'phone',
    shipperFax = 'fax',
    shipperAddress1 = 'address1',
    shipperAddress2 = 'address2',
    shipperCity = 'city',
    shipperZone = 'zone',
    shipperCountry = 'countryCode',
    shipperPostalCode = 'postalCode',
}

export const formShipperInformationInitialValues = {
    [FormShipperInformationFormValues.shipperName]: '',
    [FormShipperInformationFormValues.shipperEmail]: '',
    [FormShipperInformationFormValues.shipperPhone]: '',
    [FormShipperInformationFormValues.shipperFax]: '',
    [FormShipperInformationFormValues.shipperAddress1]: '',
    [FormShipperInformationFormValues.shipperAddress2]: '',
    [FormShipperInformationFormValues.shipperCity]: '',
    [FormShipperInformationFormValues.shipperZone]: '',
    [FormShipperInformationFormValues.shipperCountry]: '',
    [FormShipperInformationFormValues.shipperPostalCode]: '',
}